<template>
    <div>
        <div v-if="campaign.subCampaignStyles != null" class="sub-camp">
            <SubCampaign
                :subcampaign="campaign.subCampaignStyles.styles"
                :lbl="lbl"
                @onChangeSubCampaign="onChangeSubCampaign($event)"
            ></SubCampaign>
        </div>
        <div class="add-to-cart">
            <div class="wrapper-qty">
                <div class="qty-text">{{lbl.detail.amount}}</div>
                <div class="qty-btn ff-bold">
                    <img v-if="qty > 1" @click="clickReduceQty()" src="../../../../assets/new/icon/ic-minus.png"/>
                    <img v-else src="../../../../assets/new/icon/ic-minus-inactive.png"/>
                </div>
                <div class="qty-val" >{{qty}}</div>
                <div class="qty-btn ff-bold" @click="clickAddQty()">
                    <img src="../../../../assets/new/icon/ic-plus.png"/>
                </div>
            </div>
            <div class="wrapper-add-to-cart-btn">
                <div class="add-to-cart-btn" :class="campaign.qty == 0 ? 'sold-out' : ''" @click="clickAddToCart()">
                    <img v-if="campaign.qty > 0" src="../../../../assets/new/icon/ic-cart.png"/>
                    <img v-else src="../../../../assets/new/icon/ic-cart-sold-out.png"/>
                    <div>{{lbl.detail.add_cart}}</div>
                </div>
                <div class="add-to-cart-btn-1" :class="campaign.qty == 0 ? 'sold-out' : ''" @click="clickShopNow()">
                    <div>{{lbl.detail.buy_now}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import AccountMixin from "@/mixin/AccountMixin";
import Locale from '@/helper/locale/Locale';
import ConfigManager from '@/config/ConfigManager';
import BzbsCart from "@/service/BzbsCart.js";
import BzbsCartCore from '@/core/Cart/service/BzbsCart';
import AddCartModel from "@/model/CartModel.js";
import SubCampaign from './SubCampaign.vue';
export default {
    name: 'addtocart',
    mixins:[AccountMixin],
    props: {
        lbl: Object,
        campaign: Object,
        modalController: Object,
    },
    components: {
        SubCampaign
    },
    data: function() {
        return {
            cartConfig: null,
            qty: 1,
            subCampaign: null,
            subCampaignId: null
        }
    },
    created: function () {
        this.cartConfig = Account.getCacheCart()
    },
    methods: {
        addToCartApi: async function() {
            return new Promise((resolve, reject)  => {
                var strBzbsToken = Account.getToken();
                var cartItem = new AddCartModel();
                if(this.subCampaignId == null) {
                    cartItem.addItem(this.campaign.id, this.qty);
                } else {
                    cartItem.addItem(this.subCampaignId, this.qty);
                }
                // cartItem.addItem(this.campaignId, this.qty);
                var cartParams =  cartItem.getParams();
                this.modalController.loadingModal.show();
                BzbsCart.apiAddToCart(strBzbsToken, cartParams,this.cartConfig.shoppingcart_api).then((result) => {
                    this.modalController.loadingModal.hide();
                    this.cartQuantityCurrent = this.cartQuantityCurrent + this.qty;
                    this.cartQuantity = this.cartQuantityCurrent;
                    if (this.cartQuantity > 99) {
                        this.cartQuantity = "+99";
                    }
                    this.modalController.addToCartModal.show();
                    setTimeout(() =>{
                        this.modalController.addToCartModal.hide();
                        this.getCartCount()
                    }, 2000);
                    console.log(result);

                    resolve(true);
                }).catch((error) => {
                    console.log(error)
                    this.modalController.loadingModal.hide();
                    if  (error.response){
                        var err = error.response.data.error;
                        this.modalController.alertModal
                                .setMsg(err.message)
                                .show();
                    }
                    reject(false);
                });
            });
        },
        clickAddToCart: function() {
            if (this.isLogin) {
                if (this.campaign.qty === 0) return;
                this.addToCartApi();
            } else {
                this.goLogin();
            }
        },
        clickAddQty: function() {
            if(this.subCampaignId != null) {
                if (this.qty != this.subCampaign.quantity) {
                    this.qty++;
                }
            } else {
                if (this.qty != this.campaign.qty) {
                    this.qty++;
                }
            }
        },
        clickReduceQty: function() {
            if (this.qty != 1)
                this.qty--;
        },
        onChangeSubCampaign: function(value) {
            this.subCampaign = value
            this.subCampaignId = value.campaignId
        },
        clickShopNow: async function() {
            if (this.isLogin) {
                if (this.campaign.qty === 0) return;
                await this.clickAddToCart()
                this.gotoCart()
            } else {
                this.goLogin();
            }
        },
        shoppingCartUrl: function(path) {
            if (this.cartConfig.shoppingcart_url) {
                let mainUrl = this.cartConfig.shoppingcart_url
                if(path){
                    mainUrl = this.cartConfig.shoppingcart_url + path
                }
                let token = Account.getToken();
                let localeCode = Locale.getLocaleCode();
                let returnUrl = this.query.returnUrl;
                let appId = ConfigManager.getAppId()
                let api = this.cartConfig.api_prefix
                let brand = 'b2bmarketplace'
                let strUrl = mainUrl
                    + '?return_url=' + returnUrl
                    + '&token=' + token
                    + '&locale=' + localeCode
                    + '&theme=ecommerce_brand_a'
                    + '&multilang=true'
                    + '&appid=' + appId
                    + '&api=' + api
                    + '&brand=' + brand;

                return strUrl
            }
        },
        gotoCart: function(path) {
            this.blobConfig = Account.getCacheBlob();
            this.cartConfig = Account.getCacheCart();
            this.query = Account.getCacheQuery();

            const cartUrl = new URL(this.shoppingCartUrl(path));
            if (this.blobConfig.shopping_cart_redirect_b2b_marketplace) {
                cartUrl.searchParams.set('return_url', encodeURIComponent(window.location.href));
            }
            window.location.replace(cartUrl.toString());
        },

        getCartCount: async function() {
            return new Promise((resolve) => {
                BzbsCartCore.apiGetCartCount(Account.getToken()).subscribe((res) => {
                    this.$store.commit('increment', res.cart_count)
                    resolve(true);
                }, (error) => {
                    console.log(error)
                })
            })
        },

        goLogin: function() {
            this.modalController.confirmModal
                .clearModal()
                .setTitle(this.lbl.alert_popup.login.title)
                .setMsg(this.lbl.alert_popup.login.msg)
                .setBtnOk(this.lbl.alert_popup.login.btnOk)
                .setBtnCancel(this.lbl.alert_popup.login.btnCancel)
                .show();
            this.modalController.confirmModal.onClickOk(() => {
                this.$router.push('/login')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../style/base/base.scss";

.sub-camp{
    padding: 15px 0 0;
}
.wrapper-qty {
    display: flex;
    gap: 4px;
    padding-top: 22px;
    .qty-text {
        font-size: $px16;
        color: $a-gray-999999;
        width: 76px;
        margin: auto 0 ;
    }
    .qty-btn {
        margin: auto 0 ;
        img {
            width: 30px;
        }
    }
    .qty-val {
        width: 40px;
        padding: 8px 0;
        text-align: center;
    }
}
.wrapper-add-to-cart-btn{
    display: flex;
    gap: 20px;
    padding-top: 30px;
    .add-to-cart-btn {
        display: flex;
        justify-content: center;
        gap: 10px;
        color: white;
        font-size: $px16;
        background-color: $a-black-333333;
        border-radius: 8px;
        padding: 10px 0;
        width: 175px;
        height: 45px;
        img {
            width: 21px;
        }
    }
    .add-to-cart-btn-1 {
        display: flex;
        justify-content: center;
        color: white;
        font-size: $px16;
        background-color: $a-orange-f8a51b;
        border-radius: 8px;
        padding: 10px 0;
        width: 175px;
        height: 45px;
    }
    .sold-out {
        background-color: $a-gray-cdcdcd;
        color: $a-gray-999999;
    }
}
</style>
